"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var reduxStores_1 = __importDefault(require("@src/reduxStores"));
var react_redux_1 = require("react-redux");
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var History_1 = __importDefault(require("@src/History"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
// Icons
var train_svg_1 = __importDefault(require("@src/containers/SubStories/Header/icons/train.svg"));
var InfoIconV4_1 = __importDefault(require("relements/build/esm/ui/icons/InfoIconV4"));
var PiiParameterModal_1 = __importDefault(require("@src/components/BotModals/PiiParameterModal"));
// Actions
var api_1 = require("@src/containers/AIAgents/store/api");
var api_2 = require("@src/api");
var BotActions_1 = require("@src/actions/BotActions");
var AuditLogs_1 = require("@src/utils/AuditLogs");
var DomainAPI_1 = require("@src/api/DomainAPI");
// Store
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
var store_1 = __importDefault(require("@src/store"));
// Constants
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
// Components
var EditBot_1 = __importDefault(require("@src/components/BotModals/EditBot"));
var Actions_1 = __importDefault(require("./components/Actions"));
var Instructions_1 = __importDefault(require("./components/Instructions"));
var ActionDrawer_1 = __importDefault(require("./components/ActionDrawer"));
var GraphButton_1 = __importDefault(require("../SubStories/GraphButton"));
var Training_1 = __importDefault(require("../SubStories/Header/components/TrainButton/Training"));
var StyledComponets_1 = require("./components/StyledComponets");
var utils_1 = require("./utils");
var maps_1 = require("./maps");
var GenAiCreateCodeNodeModal_1 = __importDefault(require("./components/GenAiCreateCodeNodeModal"));
var InProgressModal_1 = __importDefault(require("./components/InProgressModal"));
var VoiceAgentLayout_1 = __importDefault(require("./components/VoiceAgentLayout"));
var selectors_1 = require("./store/selectors");
var PING_INTERVAL = 5000;
var AGENT_NAME_TO_TYPE_MAP = {
    0: 'Classic',
    1: 'Authentication',
};
var AIAgentComponent = function () {
    var _a, _b, _c, _d, _e;
    var _f = react_redux_1.useSelector(maps_1.stateToProps), currentAgentData = _f.currentAgentData, actionsList = _f.actionsList, availableModels = _f.availableModels, currentActionData = _f.currentActionData, agentsList = _f.agentsList, errors = _f.errors;
    var _g = maps_1.dispatchToProps(react_redux_1.useDispatch()), setCurrentAgentData = _g.setCurrentAgentData, setActions = _g.setActions, setCurrentActionData = _g.setCurrentActionData, setErrors = _g.setErrors, setAvailableModels = _g.setAvailableModels, setDomainId = _g.setDomainId, setEnvVariables = _g.setEnvVariables;
    var _h = react_1.useState(false), isDrawerActive = _h[0], setIsDrawerActive = _h[1];
    var _j = react_1.useState(false), isNewAction = _j[0], setIsNewAction = _j[1];
    var _k = react_1.useState(false), isEdited = _k[0], setIsEdited = _k[1];
    var _l = react_1.useState(false), isLoading = _l[0], setIsLoading = _l[1];
    var _m = react_1.useState(false), trainingInProgress = _m[0], setTrainingInProgress = _m[1];
    var _o = react_1.useState(false), needsTraining = _o[0], setNeedsTraining = _o[1];
    var _p = react_1.useState([]), updatedAgentsList = _p[0], setUpdatedAgentsList = _p[1];
    var _q = react_1.useState([]), piiMaskedParams = _q[0], setPiiMaskedParams = _q[1];
    var _r = react_1.useState(false), piiMaskedPopupActive = _r[0], setPiiMaskedPopupActive = _r[1];
    var _s = react_1.useState(false), createCodeNodeModalActive = _s[0], setCreateCodeNodeModalActive = _s[1];
    var _t = react_1.useState(false), isVoiceAgentEdited = _t[0], setIsVoiceAgentEdited = _t[1];
    var _u = react_1.useState(false), codeNodeActionGenerationInProgress = _u[0], setCodeNodeActionGenerationInProgress = _u[1];
    // A voice change kicks off a bulk regeneration of every workflow node's
    // stored response audio; the canvas needs this to block a node save (or
    // another voice change) from racing the job still writing that audio.
    var _v = react_1.useState(false), workflowAudioRegenerationInProgress = _v[0], setWorkflowAudioRegenerationInProgress = _v[1];
    var _w = react_1.useState(false), workflowAudioRegenerationFailed = _w[0], setWorkflowAudioRegenerationFailed = _w[1];
    var unblockRouteChangeRef = react_1.useRef(null);
    var bypassNextRouteBlockRef = react_1.useRef(false);
    var domain = (((_a = CommonStore_1["default"].getMetaTags().domain) === null || _a === void 0 ? void 0 : _a.length) &&
        CommonStore_1["default"].getMetaTags().domain) ||
        JSON.parse(localStorage.getItem('ww_iva'));
    var domainId = domain === null || domain === void 0 ? void 0 : domain.id;
    var isMultiAgent = (domain === null || domain === void 0 ? void 0 : domain['domain_type']) === 4;
    var _x = CommonStore_1["default"].getCurrentBotSettings().ai_agent_auth_enabled, aiAgentAuthEnabled = _x === void 0 ? false : _x;
    var aiAgentDomainData = react_redux_1.useSelector(selectors_1.getDomainData);
    var aiAgentDomainDataId = (_b = aiAgentDomainData === null || aiAgentDomainData === void 0 ? void 0 : aiAgentDomainData.id) !== null && _b !== void 0 ? _b : aiAgentDomainData === null || aiAgentDomainData === void 0 ? void 0 : aiAgentDomainData.domain_id;
    var isDomainDataReadyForCurrentBot = String(aiAgentDomainDataId !== null && aiAgentDomainDataId !== void 0 ? aiAgentDomainDataId : '') === String(domainId !== null && domainId !== void 0 ? domainId : '');
    var fetchActions = function (afterCodeNodeAction) {
        if (afterCodeNodeAction === void 0) { afterCodeNodeAction = false; }
        if (!currentAgentData.id)
            return;
        api_1.getActions(currentAgentData.id)
            .then(function (_a) {
            var _b, _c;
            var success = _a.success, response = _a.response;
            if (success) {
                if (response.body) {
                    setActions(response.body);
                    if (afterCodeNodeAction) {
                        if (actionsList.length < response.body.length) {
                            var actionCreated = (_b = response === null || response === void 0 ? void 0 : response.body) === null || _b === void 0 ? void 0 : _b[((_c = response.body) === null || _c === void 0 ? void 0 : _c.length) - 1];
                            BotActions_1.createAlert("Action " + ((actionCreated === null || actionCreated === void 0 ? void 0 : actionCreated.name) || '') + " created successfully.", null, MogamboConstants_1.AlertTypes.POSITIVE);
                        }
                        else {
                            BotActions_1.createAlert('Action creation failed. Please check your email for more details.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        }
                    }
                }
                else {
                    // Save empty list in store
                    setActions([]);
                }
            }
            else {
                BotActions_1.createAlert(response.error || 'Error occurred while fetching actions.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
            setIsLoading(false);
        })["catch"](function (error) {
            setIsLoading(false);
            api_2.captureException(error);
        });
    };
    var fetchModels = function () {
        api_1.getModels(domainId)
            .then(function (_a) {
            var success = _a.success, response = _a.response;
            if (success) {
                if (response.body) {
                    setAvailableModels(response.body.models);
                }
                else {
                    // Save empty list in store
                    setAvailableModels([]);
                }
            }
            else {
                BotActions_1.createAlert(response.error || 'Error occurred while fetching actions.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
            setIsLoading(false);
        })["catch"](function (error) {
            setIsLoading(false);
            api_2.captureException(error);
        });
    };
    var onInstructionsChange = function (value) {
        var updatedCurrentAgentData = cloneDeep_1["default"](currentAgentData);
        updatedCurrentAgentData.instructions = value;
        setCurrentAgentData(updatedCurrentAgentData);
        setIsEdited(true);
    };
    var onModelChange = function (model) {
        var updatedCurrentAgentData = cloneDeep_1["default"](currentAgentData);
        updatedCurrentAgentData.model_id = model.id;
        setCurrentAgentData(updatedCurrentAgentData);
        setIsEdited(true);
    };
    var onSave = function () {
        setIsLoading(true);
        var postData = {
            name: currentAgentData.name,
            description: currentAgentData.description,
            instructions: currentAgentData.instructions,
            model_id: currentAgentData.model_id,
        };
        api_1.updateAgent(domainId, currentAgentData.id, postData)
            .then(function (_a) {
            var success = _a.success, response = _a.response;
            if (success && response.success) {
                BotActions_1.createAlert(response.error || 'Successfully saved the agent data.', null, MogamboConstants_1.AlertTypes.POSITIVE);
                setIsEdited(false);
            }
            else {
                BotActions_1.createAlert(response.error || 'Error occurred while saving agent data.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
            setIsLoading(false);
        })["catch"](function (error) {
            setIsLoading(false);
            api_2.captureException(error);
        });
    };
    var onConfigure = function (action_id) {
        setIsLoading(true);
        setIsDrawerActive(false);
        setIsNewAction(false);
        api_1.getActionData(currentAgentData.id, action_id).then(function (_a) {
            var success = _a.success, response = _a.response;
            if (success) {
                if (response === null || response === void 0 ? void 0 : response.body) {
                    setCurrentActionData(response.body);
                    setErrors({
                        actionErrors: {},
                        actionParametersError: {},
                    });
                    setIsDrawerActive(true);
                }
                else {
                    BotActions_1.createAlert(response.error ||
                        'Error occurred while fetching the action data.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                }
            }
            else {
                BotActions_1.createAlert(response.error || 'Error occurred while fetching actions.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
            setIsLoading(false);
        });
        api_1.fetchEnvVariables(domainId).then(function (_a) {
            var _b;
            var success = _a.success, response = _a.response;
            if (success && ((_b = response === null || response === void 0 ? void 0 : response.body) === null || _b === void 0 ? void 0 : _b.env_variables)) {
                setEnvVariables(response.body.env_variables);
            }
            else {
                BotActions_1.createAlert('Some error occured while fetching env variables', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
        });
    };
    var onDelete = function (action_id) {
        setIsLoading(true);
        api_1.deleteAction(currentAgentData.id, action_id).then(function (_a) {
            var success = _a.success, response = _a.response;
            if (success && response.success) {
                fetchActions();
                BotActions_1.createAlert('Successfully deleted the action.', null, MogamboConstants_1.AlertTypes.POSITIVE);
            }
            else {
                BotActions_1.createAlert(response.error || 'Error occurred while deleting the action.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
            setIsLoading(false);
        });
    };
    var onDeleteClick = function (action_id) {
        BotActions_1.showConfirmationDialog({
            okTitle: 'Delete',
            cancelTitle: 'Cancel',
            title: 'Are you sure you want to delete the action?',
            message: 'You will lose this action and will not be able to recover it.',
            onOk: function () {
                onDelete(action_id);
            },
            onCancel: function () { },
            okActionType: 'danger',
        });
    };
    var onActionSave = function (actionData, callback) {
        var _a = utils_1.validateOnSave(actionData, errors), isError = _a.isError, actionErrors = _a.actionErrors, actionParametersError = _a.actionParametersError;
        if (isError) {
            BotActions_1.createAlert('Some fields are invalid. Kindly check and correct them.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            setErrors({
                actionErrors: actionErrors,
                actionParametersError: actionParametersError,
            });
            return;
        }
        setIsLoading(true);
        setIsNewAction(false);
        if (actionData.id.startsWith('new')) {
            api_1.createNewAction(currentAgentData.id, actionData)
                .then(function (_a) {
                var _b, _c, _d, _e, _f, _g;
                var success = _a.success, response = _a.response;
                if (success && ((_b = response.body) === null || _b === void 0 ? void 0 : _b.id)) {
                    setPiiMaskedParams(((_c = response === null || response === void 0 ? void 0 : response.body) === null || _c === void 0 ? void 0 : _c.pii_masked_params) || []);
                    setPiiMaskedPopupActive(!!((_e = (_d = response === null || response === void 0 ? void 0 : response.body) === null || _d === void 0 ? void 0 : _d.pii_masked_params) === null || _e === void 0 ? void 0 : _e.length));
                    onConfigure(response.body.id);
                    fetchActions();
                    if (!((_g = (_f = response === null || response === void 0 ? void 0 : response.body) === null || _f === void 0 ? void 0 : _f.pii_masked_params) === null || _g === void 0 ? void 0 : _g.length)) {
                        BotActions_1.createAlert('Successfully created the action.', null, MogamboConstants_1.AlertTypes.POSITIVE);
                    }
                    callback();
                }
                else {
                    BotActions_1.createAlert(response.error || 'Error occurred while saving the action.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                }
                setIsLoading(false);
            })["catch"](function (error) {
                BotActions_1.createAlert(error || 'Error occurred while saving the action.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            });
        }
        else {
            api_1.updateAction(currentAgentData.id, actionData.id, actionData).then(function (_a) {
                var _b, _c, _d, _e, _f;
                var success = _a.success, response = _a.response;
                if (success && response.success) {
                    setPiiMaskedParams(((_b = response === null || response === void 0 ? void 0 : response.body) === null || _b === void 0 ? void 0 : _b.pii_masked_params) || []);
                    setPiiMaskedPopupActive(!!((_d = (_c = response === null || response === void 0 ? void 0 : response.body) === null || _c === void 0 ? void 0 : _c.pii_masked_params) === null || _d === void 0 ? void 0 : _d.length));
                    setCurrentActionData(actionData);
                    fetchActions();
                    if (!((_f = (_e = response === null || response === void 0 ? void 0 : response.body) === null || _e === void 0 ? void 0 : _e.pii_masked_params) === null || _f === void 0 ? void 0 : _f.length)) {
                        BotActions_1.createAlert('Successfully saved the action.', null, MogamboConstants_1.AlertTypes.POSITIVE);
                    }
                    callback();
                }
                else {
                    BotActions_1.createAlert(response.error || 'Error occurred while saving the action.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                }
                setIsLoading(false);
            });
        }
    };
    var generateRandomString = function () {
        var prefix = 'new';
        var characters = 'abcdefghijklmnopqrstuvwxyz';
        var randomPart = '';
        for (var i = 0; i < 6; i++) {
            randomPart += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return prefix + randomPart;
    };
    var onNewAction = function () {
        var _a, _b, _c, _d;
        var _e = CommonStore_1["default"].getCurrentBotSettings().bot_properties, botProperties = _e === void 0 ? {} : _e;
        var companyDescription = (_a = botProperties === null || botProperties === void 0 ? void 0 : botProperties.company_context) === null || _a === void 0 ? void 0 : _a.trim();
        var replyTagsObject = (botProperties === null || botProperties === void 0 ? void 0 : botProperties.reply_tags) || {};
        var languageCode = Object.keys(replyTagsObject)[0];
        var replyTags = replyTagsObject[languageCode] || {};
        var companyName = (_b = replyTags['%company']) === null || _b === void 0 ? void 0 : _b.trim();
        setCurrentActionData({
            id: generateRandomString(),
            name: '',
            function_name: '',
            function_details: {
                function_params: [],
                function_description: '',
            },
            action_type: 0,
            action_details: {
                '0': {
                    custom_code_block: '',
                },
                '1': {
                    prompt: utils_1.getDefaultPrompt(companyName, companyDescription),
                },
                '2': {
                    prompt: '',
                    location_id: 'global',
                    app_id: '',
                    use_rag_for_search_only: false,
                    show_sources: true,
                },
                '3': {
                    prompt: utils_1.getDefaultPrompt(companyName, companyDescription),
                    model_id: (_d = (_c = availableModels[0]) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : '',
                },
            },
            output_format: 1,
            domain_id: domainId,
        });
        setErrors({
            actionErrors: {},
            actionParametersError: {},
        });
        setIsNewAction(true);
        setIsDrawerActive(true);
    };
    var isTrainButtonDisabled = function () {
        return store_1["default"].isProductionEnv() || !needsTraining;
    };
    var fetchStatus = react_1["default"].useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, aiAgentsTrainStatus, codeNodeActionGenerationStatus, _c, workflowAudioRegenerationStatus, audioRegenerationInProgress, audioRegenerationFailed, e_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!domain.title)
                        return [2 /*return*/];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, DomainAPI_1.getDomainStatus(domain.title)];
                case 2:
                    _a = (_d.sent()).body, _b = _a.ai_agents_train_status, aiAgentsTrainStatus = _b === void 0 ? {} : _b, codeNodeActionGenerationStatus = _a.code_node_action_generation_status, _c = _a.workflow_audio_regeneration_status, workflowAudioRegenerationStatus = _c === void 0 ? {} : _c;
                    setTrainingInProgress(aiAgentsTrainStatus.training_started);
                    setNeedsTraining(aiAgentsTrainStatus.needs_training);
                    setCodeNodeActionGenerationInProgress(codeNodeActionGenerationStatus.in_progress);
                    audioRegenerationInProgress = Boolean(workflowAudioRegenerationStatus.in_progress);
                    audioRegenerationFailed = workflowAudioRegenerationStatus.state === 'failed';
                    setWorkflowAudioRegenerationInProgress(audioRegenerationInProgress);
                    setWorkflowAudioRegenerationFailed(audioRegenerationFailed);
                    // Other places that open the same Bot Properties modal (e.g. the
                    // Sidebar's own "Edit Bot" entry) have no poll of their own; mirroring
                    // the result here lets them read it without polling again.
                    CommonStore_1["default"].setWorkflowAudioRegenerationStatus({
                        inProgress: audioRegenerationInProgress,
                        failed: audioRegenerationFailed,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _d.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [domain.id]);
    var trainAIAgents = function () {
        var domainTitle = domain.title;
        var domainId = domain.id;
        var headers = AuditLogs_1.getAuditHeaders({
            domain: domain,
            eventName: 'train_ai_agents',
        });
        BotActions_1.deployAIAgents(domainTitle, headers, domainId, {
            action: 'ai_agents',
        }, function () {
            // Set the in training flag as true and then again fetch after 3 secs from backend to confirm this.
            setTrainingInProgress(true);
        });
    };
    var createUpdatedAgentsList = function () {
        var updatedList = [];
        agentsList.forEach(function (agent) {
            updatedList.push({
                id: agent.id,
                name: AGENT_NAME_TO_TYPE_MAP[agent.agent_type],
            });
        });
        setUpdatedAgentsList(updatedList);
    };
    var getVoiceAgentsList = function () {
        return agentsList.map(function (agent) { return ({
            id: agent.id,
            name: (agent === null || agent === void 0 ? void 0 : agent.title) || AGENT_NAME_TO_TYPE_MAP[agent.agent_type] || 'Agent',
        }); });
    };
    var onAddAgentClick = function () {
        BotActions_1.createAlert('Add Agent is not available yet.', null, MogamboConstants_1.AlertTypes.WARNING);
    };
    var onAgentConfigure = function (agentId) {
        if (isEdited) {
            BotActions_1.showConfirmationDialog({
                okTitle: 'Leave',
                cancelTitle: 'Keep Editing',
                title: 'Are you sure you want to switch the agent?',
                message: "It looks like you're still working on this. You may lose the info you've entered so far if you leave now.",
                onOk: function () {
                    var agentData = agentsList.find(function (agent) { return agent.id === agentId; });
                    setCurrentAgentData(agentData);
                    bypassNextRouteBlockRef.current = true;
                    utils_1.redirectToAgent(agentId, domainId);
                    setIsEdited(false);
                    setIsDrawerActive(false);
                },
                onCancel: function () { },
                okActionType: 'danger',
            });
        }
        else {
            var agentData = agentsList.find(function (agent) { return agent.id === agentId; });
            setCurrentAgentData(agentData);
            bypassNextRouteBlockRef.current = true;
            utils_1.redirectToAgent(agentId, domainId);
            setIsDrawerActive(false);
        }
    };
    react_1["default"].useEffect(function () {
        if (unblockRouteChangeRef.current) {
            unblockRouteChangeRef.current();
            unblockRouteChangeRef.current = null;
        }
        unblockRouteChangeRef.current = History_1["default"].block(function (location) {
            var _a, _b, _c;
            if (bypassNextRouteBlockRef.current) {
                bypassNextRouteBlockRef.current = false;
                return true;
            }
            var hasUnsavedChanges = isMultiAgent ? isVoiceAgentEdited : isEdited;
            if (!hasUnsavedChanges)
                return true;
            var nextPath = "" + ((location === null || location === void 0 ? void 0 : location.pathname) || '') + ((location === null || location === void 0 ? void 0 : location.search) || '') + ((location === null || location === void 0 ? void 0 : location.hash) || '');
            var currentPath = "" + (((_a = History_1["default"] === null || History_1["default"] === void 0 ? void 0 : History_1["default"].location) === null || _a === void 0 ? void 0 : _a.pathname) || '') + (((_b = History_1["default"] === null || History_1["default"] === void 0 ? void 0 : History_1["default"].location) === null || _b === void 0 ? void 0 : _b.search) || '') + (((_c = History_1["default"] === null || History_1["default"] === void 0 ? void 0 : History_1["default"].location) === null || _c === void 0 ? void 0 : _c.hash) || '');
            if (nextPath === currentPath)
                return true;
            BotActions_1.showConfirmationDialog({
                okTitle: 'Leave',
                cancelTitle: 'Keep Editing',
                title: 'Are you sure you want to leave?',
                message: "It looks like you're still working on this. You may lose the info you've entered so far if you leave now.",
                onOk: function () {
                    if (unblockRouteChangeRef.current) {
                        unblockRouteChangeRef.current();
                        unblockRouteChangeRef.current = null;
                    }
                    bypassNextRouteBlockRef.current = true;
                    History_1["default"].push(nextPath);
                },
                onCancel: function () { },
                okActionType: 'danger',
            });
            return false;
        });
        return function () {
            if (unblockRouteChangeRef.current) {
                unblockRouteChangeRef.current();
                unblockRouteChangeRef.current = null;
            }
        };
    }, [isEdited, isMultiAgent, isVoiceAgentEdited]);
    var openBotSettings = function () {
        var _a;
        var domainData = (_a = CommonStore_1["default"].getMetaTags()) === null || _a === void 0 ? void 0 : _a.domain;
        var domain_data = (domainData === null || domainData === void 0 ? void 0 : domainData.id) ? domainData
            : JSON.parse(localStorage.getItem('ww_iva'));
        BotActions_1.openComponentModal(react_1["default"].createElement(EditBot_1["default"], { botData: domain_data, allLanguages: CommonStore_1["default"].getMetaTags().allLanguages, workflowAudioRegenerationInProgress: workflowAudioRegenerationInProgress, workflowAudioRegenerationFailed: workflowAudioRegenerationFailed, onSaveSuccess: fetchStatus }), 'Edit Bot', null, 'close', null, null, null, 'edit-bot-modal', true);
    };
    react_1["default"].useEffect(function () {
        fetchStatus();
        var interval = setInterval(function () {
            fetchStatus();
        }, PING_INTERVAL);
        return function () {
            clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [domainId]);
    react_1["default"].useEffect(function () {
        setIsLoading(true);
        setDomainId(domainId);
        createUpdatedAgentsList();
        fetchActions();
        fetchModels();
    }, [currentAgentData.id]);
    react_1["default"].useEffect(function () {
        // If the state has currentActionData which means the last action didn't closed the AIActionDrawer.
        // That's why we're calling the onConfigure for the last selected action.
        // This happens when the user opens the Code Editor for the action and close it.
        if (currentActionData.id && !isDrawerActive)
            onConfigure(currentActionData.id);
    }, []);
    if (isMultiAgent) {
        return (react_1["default"].createElement(box_1["default"], { padding: "24px", style: { overflowY: 'scroll' }, flexDirection: "column" }, !isDomainDataReadyForCurrentBot ? (react_1["default"].createElement(StyledComponets_1.StyledOverlayLoader, null)) : (react_1["default"].createElement(VoiceAgentLayout_1["default"], { key: "voice-agent-layout-" + domainId, onAddAgentClick: onAddAgentClick, isEdited: isEdited, onSave: onSave, onDeleteClick: onDeleteClick, onDirtyStateChange: function (dirty) { return setIsVoiceAgentEdited(dirty); }, workflowAudioRegenerationInProgress: workflowAudioRegenerationInProgress, workflowAudioRegenerationFailed: workflowAudioRegenerationFailed }))));
    }
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(box_1["default"], { padding: "24px", style: { overflowY: 'scroll' }, flexDirection: "column" },
            isLoading && react_1["default"].createElement(StyledComponets_1.StyledOverlayLoader, null),
            react_1["default"].createElement(box_1["default"], { padding: "0px 8px", marginBottom: "16px", flexDirection: "row", justifyContent: "space-between" },
                react_1["default"].createElement(box_1["default"], { padding: "0" },
                    react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select an agent", themed: true, options: updatedAgentsList, value: (_c = updatedAgentsList.filter(function (agent) { return agent.id === currentAgentData.id; })) === null || _c === void 0 ? void 0 : _c[0], optionKey: "name", onChange: function (val) { return onAgentConfigure(val.id); } })),
                react_1["default"].createElement(box_1["default"], { padding: "0", justifyContent: "flex-end" },
                    react_1["default"].createElement(box_1["default"], { style: { display: 'grid', alignContent: 'baseline' } }, isTrainButtonDisabled() ? (react_1["default"].createElement(GraphButton_1["default"], { disabled: true, onClick: trainAIAgents, trainButton: true, blink: needsTraining && !isTrainButtonDisabled() },
                        react_1["default"].createElement(icon_1["default"], { src: train_svg_1["default"] }),
                        trainingInProgress ? (react_1["default"].createElement(Training_1["default"], { text: "Training AI Agent" })) : ('Train AI Agent'))) : (react_1["default"].createElement(GraphButton_1["default"], { disabled: trainingInProgress || isTrainButtonDisabled(), onClick: trainAIAgents, trainButton: true, blink: needsTraining && !isTrainButtonDisabled() },
                        react_1["default"].createElement(icon_1["default"], { src: train_svg_1["default"] }),
                        trainingInProgress ? (react_1["default"].createElement(Training_1["default"], { text: "Training AI Agent" })) : ('Train AI Agent')))),
                    react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, variant: isEdited && !store_1["default"].isProductionEnv() ? 'primary' : 'disabled', disabled: !isEdited || store_1["default"].isProductionEnv(), onClick: onSave, height: "33px", marginTop: "8px" }, "Save"))),
            currentAgentData.agent_type === 1 && !aiAgentAuthEnabled && (react_1["default"].createElement(StyledComponets_1.StyledInfoContainer, { variant: "error" },
                react_1["default"].createElement(InfoIconV4_1["default"], { size: "small", iconColor: "black.haptik", marginRight: "6px" }),
                react_1["default"].createElement(text_1["default"], null,
                    "Authentication is currently disabled for this bot. To enable it,",
                    ' ',
                    react_1["default"].createElement(StyledComponets_1.StyledClickableText, { onClick: openBotSettings }, "click here"),
                    ' ',
                    "to go to Bot Settings."))),
            react_1["default"].createElement(box_1["default"], { padding: "8px", marginTop: "8px", marginBottom: "16px", style: {
                    display: 'grid',
                    width: 'fit-content',
                } },
                react_1["default"].createElement(text_1["default"], { variant: "h1.semi-bold", color: "black.haptik" }, "Model"),
                react_1["default"].createElement(StyledComponets_1.StyledText, null, "Choose the LLM Model that would be powering your AI Agent"),
                react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select a value", themed: true, options: availableModels, value: (_e = (_d = availableModels.filter(function (model) { return model.id === currentAgentData.model_id; })) === null || _d === void 0 ? void 0 : _d[0]) !== null && _e !== void 0 ? _e : availableModels[0], optionKey: "id", onChange: onModelChange })),
            react_1["default"].createElement(box_1["default"], { flexDirection: "row", style: { flex: 1, gap: '24px' } },
                react_1["default"].createElement(Actions_1["default"], { allActions: actionsList !== null && actionsList !== void 0 ? actionsList : [], onConfigure: onConfigure, onDelete: onDeleteClick, onNewAction: onNewAction }),
                react_1["default"].createElement(Instructions_1["default"], { value: currentAgentData.instructions, setValue: onInstructionsChange }))),
        react_1["default"].createElement(ActionDrawer_1["default"], { isDrawerActive: isDrawerActive, setIsDrawerActive: setIsDrawerActive, onSave: onActionSave, isNewAction: isNewAction, piiMaskedParams: piiMaskedParams, setCreateCodeNodeModalActive: setCreateCodeNodeModalActive }),
        react_1["default"].createElement(PiiParameterModal_1["default"], { active: piiMaskedPopupActive, onClose: function () {
                setPiiMaskedPopupActive(false);
            }, piiParameters: piiMaskedParams }),
        react_1["default"].createElement(GenAiCreateCodeNodeModal_1["default"], { active: createCodeNodeModalActive, onClose: function () {
                setCreateCodeNodeModalActive(false);
            }, agentId: currentAgentData.id, setIsActionGenerationInProgress: setCodeNodeActionGenerationInProgress }),
        react_1["default"].createElement(InProgressModal_1["default"], { active: !!codeNodeActionGenerationInProgress, startTime: typeof codeNodeActionGenerationInProgress === 'string'
                ? parseInt(codeNodeActionGenerationInProgress, 10)
                : null, onClose: function () {
                setCodeNodeActionGenerationInProgress(false);
                // fetchActions();
            }, fetchActions: fetchActions })));
};
var AIAgent = function (props) {
    return (react_1["default"].createElement(react_redux_1.Provider, { store: reduxStores_1["default"] },
        react_1["default"].createElement(AIAgentComponent, __assign({}, props))));
};
exports["default"] = AIAgent;
